module.exports = __webpack_public_path__ + "img/brand_bg_footer.addfa37e.svg";